/*! HorizontalSmoothScrollLayout | MIT License | https://github.com/codrops/HorizontalSmoothScrollLayout */

import LocomotiveScroll from "locomotive-scroll";
import { isSafari, preloadImages, preloadFonts, clamp, map } from "./utils";
import Cursor from "./cursor";

const lscroll = new LocomotiveScroll({
  el: document.querySelector<HTMLElement>("[data-scroll-container]") as
    | HTMLElement
    | undefined,
  smooth: true,
  direction: "horizontal",
  multiplier: isSafari ? 2 : 1,
});

// let's skew the images when scrolling. The faster we scroll the higher the skew value
// skew interval from -5 to 5
// "fast scrolling" means the distance from the previous scrolling position to the current one is high. We consider a interval of [-50,50] for the min/max distance
const MIN_SKEW = -5;
const MAX_SKEW = 5;
let scroll = { cache: 0, current: 0 };

const allImgs = [...document.querySelectorAll<HTMLElement>(".menu__item-img")];
const scrollProgressContainer = document.querySelector<HTMLElement>(
  ".scroll-progress__track"
);

lscroll.on("scroll", (obj) => {
  scroll.current = obj.scroll.x;
  const distance = scroll.current - scroll.cache;
  scroll.cache = scroll.current;
  const skewVal = map(distance, -50, 50, MIN_SKEW, MAX_SKEW);
  const progressInPercentage = (scroll.current / obj.limit.x) * 100;

  if (scrollProgressContainer) {
    scrollProgressContainer.style.transform =
      "scaleX(" + progressInPercentage + "%)";
  }

  allImgs.forEach(
    (el: HTMLElement) =>
      (el.style.transform =
        "skewX(" + clamp(skewVal, MIN_SKEW, MAX_SKEW) + "deg)")
  );
});
lscroll.update();

// Preload images and fonts
Promise.all([
  preloadImages(".menu__item-imginner"),
  preloadFonts("zkq2mjw"),
]).then(() => {
  // Remove loader (loading class)
  document.body.classList.remove("loading");

  // Initialize custom cursor
  const cursor = new Cursor(
    document.querySelector<HTMLElement>(".cursor"),
    document.querySelector<HTMLElement>(".cursor__outline")
  );

  // Mouse effects on all links and others
  [...document.querySelectorAll("a.menu__item-link")].forEach((link) => {
    link.addEventListener("mouseenter", () => cursor.enter());
    link.addEventListener("mouseleave", () => cursor.leave());
  });
});
